import  { HANDLE_REPORT, RESET } from "../actions";
import moment from "moment";

const initialState = {
    // startDate: moment().subtract(1, "month").startOf('month'),
    // endDate: moment().subtract(1, "month").endOf('month'),
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
    filterType: 3,
    search: "ALL",
    jobCard: [],
    completed: 0,
    incentive: 0,
    incentive_records: 0,
    service_entry: 0,

    service_count: 0,
    new_installation_count: 0,
    
    totalbillamount: 0,
    discount: 0,
    oldbatteryamount: 0,
    amountcollected: 0,
    credit: 0,

    accepted: 0,
    notAccepted: 0,
    officeTaken: 0,
    onGoing: 0,
    payment: 0,
    pending: 0,
    ready: 0,
    delivered: 0,
    received: 0,
    rejected: 0,
    smallWork: 0,
    warranty: 0,
    reportApiCalled: false,
    jobcardCount: 0,

    display_type: 2,

    verified: 0,
    notverified: 0,
    declined: 0,

    amc_count: 0,

    scrab_count: 0,
    standby_count: 0,
    claim_motor_count: 0,
    online_service_count: 0,
    nups_service_count: 0,
    ss_service_count: 0,

    toggleTable: true,
};

const Report = (state = initialState, action) => {
    switch(action.type) {
        case HANDLE_REPORT : 
            return {
                ...state,
                ...action.data
            }
        case RESET :
            return initialState
        default:
            return state;
    }
}

export default Report;